<template>
  <div v-if="isEditing">To be deleted.</div>
</template>

<script lang="ts" setup>
const { isEditing } = defineBlokkli({
  bundle: 'carousel',
})
</script>
